import React from 'react'
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import { normalizeAvatarSrc } from '../Utils/avatarSrc'

class EventAvatar extends React.Component {

  render() {
    const { anearEvent } = this.props
    const appAttrs = anearEvent.zone.app.attributes
    const user = anearEvent.user
    const showCreatorAvatar = !anearEvent.hosted && user

    const size = Number(this.props.size || 80)
    const insetOverlay = Boolean(this.props.insetOverlay)
    const appIconSize = `${size}px`
    const userAvatarSize = `${Math.round(size * 0.45)}px`
    const overlayPosition = insetOverlay
      ? { bottom: 0, right: 0 }
      : {
          bottom: '-0.25rem',
          right: size <= 72 ? '-0.5rem' : '-0.75rem'
        }

    return (
      <Box sx={{ height: appIconSize, width: appIconSize, position: 'relative', flexShrink: 0 }}>
        <Avatar
          src={appAttrs['icon-url']}
          aria-label={showCreatorAvatar ? 'Event App Icon with Creator Avatar' : 'Event App Icon'}
          sx={{
            height: appIconSize,
            width: appIconSize,
            zIndex: 1
          }}
        />
        {showCreatorAvatar && (
          <Box
            sx={{
              position: 'absolute',
              ...overlayPosition,
              zIndex: 2,
              border: '2px solid rgba(255,255,255,0.85)',
              borderRadius: '50%',
              height: userAvatarSize,
              width: userAvatarSize
            }}
          >
            <Avatar
              src={normalizeAvatarSrc(user.avatarUrl()) || undefined}
              alt={user.name()}
              sx={{
                height: '100%',
                width: '100%',
                bgcolor: 'primary.main',
                color: '#fff',
                fontSize: '1.5rem',
                fontWeight: 600
              }}
            >
              {user.initial()}
            </Avatar>
          </Box>
        )}
      </Box>
    )
  }
}

export default EventAvatar


